module.exports = __webpack_public_path__ + "img/modelRed.8fe64552.jpg";